<template>
  <el-menu
    background-color="#FFFFFF"
    text-color="#333333"
    active-text-color="#f42551"
    class="el-menu-container sidear_container"
    :router="true"
    :collapse="isCollapse"
    mode="vertical"
    id="message-container"
    :default-openeds="openeds"
    :default-active="activeIndex"
  >
    <el-menu-item index="/home" class="el_menu_home">
      <div class="el-menu-img icon1"></div>
      <span>首页</span>
    </el-menu-item>

    <el-submenu
      index="/account"
      :class="{ isOpen: currentIndex == '/account' }"
    >
      <template slot="title" class="title">
        <div class="el-menu-img icon2"></div>
        <span>账号管理</span>
      </template>
      <el-menu-item-group>
        <el-menu-item index="/contact">联系人信息</el-menu-item>
        <el-menu-item index="/address">发货地</el-menu-item>
        <el-menu-item index="/setupPassword">设置密码</el-menu-item>
        <el-menu-item index="/applyAccount" v-if="userInfo.memberAccount && userInfo.memberAccount.isMember == 1">申请子账号</el-menu-item>
        <el-menu-item index="/news" @click="myNews()">我的消息<span class="news_num" v-if="count">{{ count }}</span></el-menu-item>
        <el-menu-item index="/myAttentions">我的关注</el-menu-item>
      </el-menu-item-group>
    </el-submenu>

    <el-submenu
      index="/purchase"
      :class="{ isOpen: currentIndex == '/purchase' }"
    >
      <template slot="title">
        <div class="el-menu-img icon3"></div>
        <span>采购管理</span>
      </template>
      <el-menu-item-group>
        <el-menu-item index="/publish_purchase">发布采购</el-menu-item>
        <el-menu-item index="/purchase_list">采购列表</el-menu-item>
        <el-menu-item index="/purchase_hangqing">原料行情</el-menu-item>
      </el-menu-item-group>
    </el-submenu>

    <el-submenu index="4" :class="{ isOpen: currentIndex == '4' }">
      <template slot="title">
        <div class="el-menu-img icon4"></div>
        <span>企业管理</span>
      </template>
      <el-menu-item-group>
        <el-menu-item index="/supplier_enter" v-if="status !== 'PASS' && userInfo.hasSupplierInformation == 0">入驻供应商</el-menu-item>
        <el-menu-item index="/set_store" v-if="(userInfo.identityType !== 1 || !userInfo.identityType)">商铺设置</el-menu-item>
        <el-menu-item index="/issue_supply" v-if="userInfo.identityType !== 1">发布供应</el-menu-item>
        <el-menu-item index="/online_products" v-if="userInfo.identityType !== 1">已上线产品</el-menu-item>
        <el-menu-item index="/offline_products" v-if="userInfo.identityType !== 1">已下线产品</el-menu-item>
      </el-menu-item-group>
    </el-submenu>

    <el-submenu index="5" :class="{ isOpen: currentIndex == '5' }">
      <template slot="title">
        <div class="el-menu-img icon5"></div>
        <span>营销管理</span>
      </template>
      <el-menu-item-group>
        <el-menu-item index="/message_marketing">短信营销</el-menu-item>
        <el-menu-item index="/advertisement_putting">广告服务</el-menu-item>
      </el-menu-item-group>
    </el-submenu>

    <el-submenu index="/serve" :class="{ isOpen: currentIndex == '/serve' }">
      <template slot="title">
        <div class="el-menu-img icon6"></div>
        <span>优塑服务</span>
      </template>
      <el-menu-item-group>
        <el-menu-item index="/connect_customerService">联系客服</el-menu-item>
        <el-menu-item index="/support_center">帮助中心</el-menu-item>
        <el-menu-item index="/feedback">反馈意见</el-menu-item>
        <el-menu-item index="/accountEdit" v-if="userInfo.hasSupplierInformation !== 0">会员介绍</el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>

<script>
export default {
  data() {
    return {
      isCollapse: false,
      count: 0,
      userInfo: {
        identityType: 0,
        memberAccount: {
          isMember: 0
        },
        hasSupplierInformation: 0
      },
      currentIndex: "",
      openeds: ["/home", "/account", "/purchase", "4", "5", "/serve"],
      activeIndex: "/home",
      scrollTop: 0,
      status: ""
    };
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        var scroll = document.getElementById('message-container')
        scroll.addEventListener('scroll', this.handleScroll, true)
      })
    }, 800);
  },
  watch: {
    $route: {
      handler(route) {
        // 保存滚动位置
        const scroll = document.getElementById('message-container');
        if (scroll) {
          this.scrollTop = scroll.scrollTop;
        }
        this.activeIndex = route.path;
        // 恢复滚动位置
        this.$nextTick(() => {
          const scroll = document.getElementById('message-container');
          if (scroll) {
            scroll.scrollTop = this.scrollTop;
          }
        });
      },
      immediate: true
    }
  },
  beforeDestroy() {
    setTimeout(() => {
      this.$nextTick(() => {
        var scroll = document.getElementById('message-container')
        scroll.removeEventListener('scroll', this.handleScroll)
      })
    }, 800);
  },
  created() {
    this.getNotificationUnread();
    this.getUserInfo();
    this.SupplierList()
  },
  methods: {
    SupplierList() {
      this.$apiFun.SupplierList().then(res => {
        if (res.result.status) {
          this.status = res.result.status
        }
      })
    },
    handleScroll () {
      // 处理滚动事件
    },
    async getUserInfo() {
      let res = await this.$apiFun.getUserInfo();
      this.userInfo = res.result;
    },
    handleOpen(keyPath) {
      this.currentIndex = keyPath;
    },
    async getNotificationUnread() {
      let res = await this.$apiFun.getNotificationUnread();
      this.count = res.result;
    },
    async myNews() {
      let params = {
        toMemberId: this.userInfo.id,
      };
      let res = await this.$apiFun.allRead(params);
      if (res.code == 200) {
        this.getNotificationUnread();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-menu-container:not(.el-menu--collapse) {
  width: 2.7rem;
  max-height: calc(100vh - 1.8rem);
  padding: 0.1rem 0;
  position: sticky;
  top: 1.2rem;
  margin-left: -1.3rem;
}
.el-menu-container {
  height: 100%;
  box-shadow: 0px 3px 20px 0px rgba(230, 230, 230, 0.8);
  border-radius: 10px 0 0 10px;
}
/deep/.el-menu-item-group__title {
  display: none;
}
/deep/ .isOpen {
  .el-submenu__title {
    background: #f42551 !important;
    color: #ffffff !important;
  }
}
/deep/.el-menu-item {
  height: 0.42rem !important;
  line-height: 0.42rem !important;
  padding: 0px 0px 0px 5px !important;
  margin: 0.1rem 0.1rem 0rem 0.1rem !important;
  min-width: auto !important;
  display: flex;
  justify-content: flex-start !important;
  align-items: center !important;
  border-radius: 10px;
  font-size: 0.21rem;
  .news_num {
    width: 0.24rem;
    height: 0.24rem;
    line-height: 0.24rem;
    background: #f42551;
    border-radius: 12px;
    font-size: 0.16rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    margin-left: 0.1rem;
  }
}
/deep/.el-menu-item-group li {
  padding-left: 0.4rem !important;
}

/deep/.el-icon-grape {
  float: left !important;
}
/deep/.el-submenu__title {
  display: flex;
  align-items: center !important;
  height: 0.42rem !important;
  line-height: 0.42rem !important;
  padding: 0rem 0rem 0rem 0.05rem !important;
  margin: 0.1rem 0.1rem 0rem 0.1rem !important;
  border-radius: 10px;
  font-size: 0.22rem;
}
.el-menu-img {
  width: 0.27rem;
  height: 0.26rem;
  margin-right: 0.1rem;
}
.icon1 {
  background: url(../../../assets/layout/icon_sy@2x.png);
  background-size: 100% 100%;
}
.isOpen .icon1 {
  background: url(../../../assets/layout/icon_sy_white@2x.png);
  background-size: 100% 100%;
}
.el_menu_home {
  /deep/.el-menu-item__icon {
    display: none !important;
  }
}
.icon2 {
  background: url(../../../assets/layout/icon_zhgl@2x.png);
  background-size: 100% 100%;
}
.isOpen .icon2 {
  background: url(../../../assets/layout/icon_zhgl_white@2x.png);
  background-size: 100% 100%;
}
.icon3 {
  background: url(../../../assets/layout/icon_cggl@2x.png);
  background-size: 100% 100%;
}
.isOpen .icon3 {
  background: url(../../../assets/layout/icon_cggl_white@2x.png);
  background-size: 100% 100%;
}
.icon4 {
  background: url(../../../assets/layout/icon_qygl@2x.png);
  background-size: 100% 100%;
}
.isOpen .icon4 {
  background: url(../../../assets/layout/icon_qygl_white@2x.png);
  background-size: 100% 100%;
}
.icon5 {
  background: url(../../../assets/layout/icon_yxgl@2x.png);
  background-size: 100% 100%;
}
.isOpen .icon5 {
  background: url(../../../assets/layout/icon_yxgl_white@2x.png);
  background-size: 100% 100%;
}
.icon6 {
  background: url(../../../assets/layout/icon_usfw@2x.png);
  background-size: 100% 100%;
}
.isOpen .icon6 {
  background: url(../../../assets/layout/icon_usfw_white@2x.png);
  background-size: 100% 100%;
}

.sidear_container {
  max-height: 100vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 4px;
    height: 1px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background: #efefef;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(167, 203, 244, 1);
    background: #cccccc;
  }
}
</style>